import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "content__before"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  class: "hotel-distance pb-1",
  dir: "auto"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_10 = {
  key: 2,
  class: "pick-up-time"
}
const _hoisted_11 = {
  for: "",
  class: "mr-4 mb-0"
}
const _hoisted_12 = { class: "pick-up-time__modal" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "hotel-horizontal" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "hotel-button-see-more" }
const _hoisted_17 = {
  key: 1,
  class: "hotel-map text-center"
}
const _hoisted_18 = {
  key: 0,
  class: "map"
}
const _hoisted_19 = {
  key: 1,
  class: "content__after"
}
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "content__hotel-info" }
const _hoisted_22 = { class: "hotel-information" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = { class: "prefix mr-1" }
const _hoisted_25 = ["title"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "d-flex" }
const _hoisted_28 = { class: "prefix mr-1" }
const _hoisted_29 = { class: "text-truncate" }
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_32 = { class: "prefix mr-1" }
const _hoisted_33 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_34 = { class: "prefix mr-1" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "text-truncate truncate-text" }
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = { class: "prefix mr-1" }
const _hoisted_40 = { class: "text-truncate" }
const _hoisted_41 = { class: "d-flex" }
const _hoisted_42 = { class: "text-truncate" }
const _hoisted_43 = {
  key: 0,
  class: "prefix"
}
const _hoisted_44 = {
  key: 1,
  class: "prefix"
}
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = { class: "prefix mr-1" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "d-flex" }
const _hoisted_49 = { class: "prefix mr-1" }
const _hoisted_50 = { class: "text-truncate" }
const _hoisted_51 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_52 = { class: "prefix mr-1" }
const _hoisted_53 = { class: "text-truncate" }
const _hoisted_54 = { class: "d-flex" }
const _hoisted_55 = { class: "prefix mr-1" }
const _hoisted_56 = {
  class: "text-truncate",
  style: {"text-decoration":"underline"}
}
const _hoisted_57 = {
  key: 3,
  class: "d-flex"
}
const _hoisted_58 = { class: "prefix mr-1" }
const _hoisted_59 = { class: "text-truncate" }
const _hoisted_60 = {
  key: 4,
  class: "d-flex"
}
const _hoisted_61 = { class: "text-underline" }
const _hoisted_62 = { class: "mr-1" }
const _hoisted_63 = { class: "text-truncate" }
const _hoisted_64 = {
  key: 5,
  class: "d-flex"
}
const _hoisted_65 = {
  key: 6,
  class: "button-call-hrs"
}
const _hoisted_66 = ["href"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_68 = {
  key: 0,
  class: "shuttle-bus-infor"
}
const _hoisted_69 = { class: "prefix" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "prefix" }
const _hoisted_74 = { class: "line-original" }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "prefix" }
const _hoisted_78 = { class: "line-original" }
const _hoisted_79 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_80 = { class: "prefix" }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = {
  key: 0,
  class: "hotel-button-select"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_StyledSFSHotelCard = _resolveComponent("StyledSFSHotelCard")!

  return (_openBlock(), _createBlock(_component_StyledSFSHotelCard, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, { class: "hotel-card" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, [
            (_ctx.isAfter)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_1) + ":", 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.hotelInfo.name), 1)
          ]),
          _createVNode(_component_Carousel, {
            autoplay: 5000,
            "wrap-around": _ctx.wrapAround,
            "mouse-drag": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotelImages, (imgUrl) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: imgUrl }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "carousel__item",
                      src: imgUrl,
                      onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgDefault && _ctx.imgDefault(...args)))
                    }, null, 40, _hoisted_2)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["wrap-around"]),
          (!_ctx.isAfter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (
                _ctx.hotelInfo.road_distance_airport ||
                !_ctx.hotelInfo.road_distance_airport ||
                _ctx.hotelInfo.distance_between ||
                !_ctx.hotelInfo.distance_between
              )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createTextVNode("  " + _toDisplayString(parseFloat(_ctx.hotelInfo.road_distance_airport || _ctx.hotelInfo.distance_between).toFixed(1)) + " " + _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_18) + " ", 1),
                          (!_ctx.getOptionTaxi)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_19), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getOptionTaxi), 1))
                        ]))
                      : (!_ctx.hotelInfo.distance || !_ctx.hotelInfo.distance_between)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_20), 1))
                        : _createCommentVNode("", true),
                    (_ctx.isShowGGMap)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_21), 1),
                          _createElementVNode("span", {
                            class: "pick-up-time__value",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true))
                          }, _toDisplayString(_ctx.timePickup['HH'] + ':' + _ctx.timePickup['mm']), 1),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogVisible,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
                              center: "true",
                              "show-close": "false"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_22), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.sortDescription)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "hotel-description",
                        innerHTML: _ctx.hotelInfo.description_en_GB
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_14,
                (!_ctx.isShowGGMap)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("a", {
                          href: "javascript:",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortDescription = !_ctx.sortDescription))
                        }, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_23), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isShowGGMap)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          href: "javascript:",
                          class: "hotel-button-see-more",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSeeMoreShowMap = !_ctx.isSeeMoreShowMap))
                        }, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_24), 1)
                      ]),
                      (_ctx.isSeeMoreShowMap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_25), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAfter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_2), 1),
                        _createElementVNode("span", {
                          title: _ctx.getAddressHotel,
                          class: "text-truncate"
                        }, [
                          _createElementVNode("a", {
                            href: 'http://maps.google.com/?q=' + _ctx.getAddressHotel,
                            target: "_blank"
                          }, _toDisplayString(_ctx.getAddressHotel), 9, _hoisted_26)
                        ], 8, _hoisted_25)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_3), 1),
                        _createElementVNode("span", _hoisted_29, [
                          _createElementVNode("a", {
                            href: 'tel:' + _ctx.hotelInfo.telephone,
                            class: "phone-number"
                          }, _toDisplayString(_ctx.hotelInfo.telephone), 9, _hoisted_30)
                        ])
                      ]),
                      (_ctx.checkDate() && _ctx.checkinDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_46 ?? 'Check in') + ":", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.checkinInfo), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hotelInfo.checkout_time && _ctx.checkoutDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_47 ?? 'Check out') + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.checkoutInfo), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", {
                          class: "prefix mr-1",
                          innerHTML: 
                    _ctx.replaceStr(
                      _ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_33 || 'For <number_person> person(s):',
                      ['<number_person>'],
                      _ctx.hotelInfo.num_paxs
                    )
                  
                        }, null, 8, _hoisted_36),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.hotelInfo.name_pax_group), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_4), 1),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.hotelInfo.num_day), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          (_ctx.checkinDate)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_34) + ":", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.checkinDate)) + "   ", 1),
                          (_ctx.checkoutDate)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_35) + ":", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.checkoutDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_5), 1),
                        (_ctx.hotelRoomType)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "text-truncate",
                              innerHTML: _ctx.hotelRoomType
                            }, null, 8, _hoisted_47))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.groundHandlerMessage?.hotel?.SFS_LANG_ROW_43 || 'Hotel voucher code') + ":", 1),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.hotelInfo.code), 1)
                      ]),
                      (_ctx.hotelInfo.ws_reference)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_6), 1),
                            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.hotelInfo.ws_reference), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_7), 1),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.hotelInfo.ws_reference ? 'HRS' : 'SFS360'), 1)
                      ]),
                      (!_ctx.hotelInfo.ws_booking)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_36 ? _ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_36 : 'Debit') + ":", 1),
                            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.airline.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hotelInfo.ws_booking && _ctx.hotelInfo.ws_booking.BookingReference)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("p", _hoisted_61, [
                              _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_38 || 'Reservation Number') + ":", 1),
                              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.hotelInfo.ws_booking.BookingReference), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hotelInfo.ws_booking && _ctx.hotelInfo.ws_booking.BookingReference)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_40 || _ctx.defaultExplainHRSPayment), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hotelInfo.ws_booking && _ctx.hotelInfo.ws_booking.BookingReference)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("a", {
                              href: `tel: ${_ctx.hotelInfo.phone_number_hrs_support || '+492212077600'}`
                            }, [
                              _hoisted_67,
                              _createTextVNode(" " + _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_39 || 'Click here to call hotel support'), 1)
                            ], 8, _hoisted_66)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isCheckBlockDate && _ctx.hotelInfo.transport_available == 1 && _ctx.hotelInfo.transport_id == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_8) + " " + _toDisplayString(_ctx.flightDate || 'Today'), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBlockDate, (blockDate, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              style: {"display":"flex","gap":"1.5rem"}
                            }, [
                              (blockDate.operating_opentime && blockDate.operating_closetime)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(blockDate.operating_opentime) + " - " + _toDisplayString(blockDate.operating_closetime), 1))
                                : _createCommentVNode("", true),
                              (blockDate.frequency_service)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, " every " + _toDisplayString(blockDate.frequency_service) + " min ", 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          (_ctx.hotelInfo.pickup_details)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_9), 1),
                                _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.hotelInfo.pickup_details), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.hotelInfo.transport_available == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          (_ctx.hotelInfo.desc_direction_hotel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_9), 1),
                                _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.hotelInfo.desc_direction_hotel), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.hotelInfo.comment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_42 || 'Note from airline'), 1),
                          (_ctx.hotelInfo.comment)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                innerHTML: _ctx.linkify(_ctx.hotelInfo.comment)
                              }, null, 8, _hoisted_81))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.isAfter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
            _createVNode(_component_el_button, {
              class: "btn-action",
              onClick: _ctx.handleBookHotel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.groundHandlerMessage?.hotel.SFS_LANG_ROW_26), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}